var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnSwitchHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52857 0.528514C8.78892 0.268165 9.21103 0.268165 9.47138 0.528514L12.1381 3.19518C12.3984 3.45553 12.3984 3.87764 12.1381 4.13799L9.47138 6.80466C9.21103 7.06501 8.78892 7.06501 8.52857 6.80466C8.26823 6.54431 8.26823 6.1222 8.52857 5.86185L10.0572 4.33325H0.99998C0.63179 4.33325 0.333313 4.03478 0.333313 3.66659C0.333313 3.2984 0.63179 2.99992 0.99998 2.99992H10.0572L8.52857 1.47132C8.26823 1.21097 8.26823 0.788864 8.52857 0.528514ZM4.13805 7.19518C4.3984 7.45553 4.3984 7.87764 4.13805 8.13799L2.60946 9.66659H11.6666C12.0348 9.66659 12.3333 9.96506 12.3333 10.3333C12.3333 10.7014 12.0348 10.9999 11.6666 10.9999H2.60946L4.13805 12.5285C4.3984 12.7889 4.3984 13.211 4.13805 13.4713C3.8777 13.7317 3.45559 13.7317 3.19524 13.4713L0.528575 10.8047C0.268226 10.5443 0.268226 10.1222 0.528575 9.86185L3.19524 7.19518C3.45559 6.93483 3.8777 6.93483 4.13805 7.19518Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSwitchHorizontal);
export default __webpack_public_path__ + "static/media/icn-switch-horizontal.e89c9e78e5f496ff5bfa16cb4369ebec.svg";
export { ForwardRef as ReactComponent };